import type {
  INotifyMeInitiatedEvent,
  INotifyMeInitiatedInput,
} from '../types/clickEvents';

const notifyMeInitiated = (
  input: INotifyMeInitiatedInput,
): Omit<INotifyMeInitiatedEvent, 'event'> => ({
  linkDetails: input.linkDetails,
});

export default notifyMeInitiated;
